export default function textSerializer() {
  return function serialize(fragment) {
    return fragment.getBlocks().map(function (block) {
      return block.text;
    }).join('\n') || fragment.text;
  };
}